export function initFloatingCTA() {
    [...document.querySelectorAll('.c-floating-cta:not(.-initialized)')].forEach((item) => handleFloatingCTA(item));
}

function handleFloatingCTA(group) {
    group.classList.add('-initialized');

    const inner = group.querySelector('.c-floating-cta__inner');
    const open = group.querySelector('.c-floating-cta__inner-label.open');
    const close = group.querySelector('.c-floating-cta__inner-label.close');

    open.addEventListener('click', function() {
        inner.classList.toggle('-is-active');
    });

    close.addEventListener('click', function() {
        inner.classList.toggle('-is-active');
    });
}
